import { render, staticRenderFns } from "./hub-sampleform.vue?vue&type=template&id=28e61188"
import script from "./hub-sampleform.vue?vue&type=script&lang=js"
export * from "./hub-sampleform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports